import { render } from "./Redirect.vue?vue&type=template&id=6357df94"
import script from "./Redirect.vue?vue&type=script&lang=js"
export * from "./Redirect.vue?vue&type=script&lang=js"

import exportComponent from "/home/ali/PhpstormProjects/insta-catalog-view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__